import { useNavigate } from "react-router-dom";

import styles from "./Footer.module.scss";

import logo from "../../assets/logo.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars } from "@fortawesome/free-solid-svg-icons";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { useState } from "react";
import {
  faFacebookF,
  faFacebookSquare,
  faInstagram,
  faTiktok,
} from "@fortawesome/free-brands-svg-icons";

const Footer: React.FC = () => {
  const redirect = useNavigate();
  const path = window.location.pathname;

  return (
    <>
      <div
        className={`col-12 d-flex flex-md-row flex-column  align-items-start justify-content-around mt-10 text-tahoma  mb-4  color-greyText ${styles.footerContainer} pt-4 `}
      >
        <div className="col-md-5 col-12 p-4 p-md-0 d-flex flex-row align-items-start justify-content-md-start justify-content-center  ">
          <span>
            Piazza Santi Pietro e Paolo, 15, 35127 Padova PD <br /> P.iva
            00384080184. REA: PD - 440632. Cap. Sociale 50'000€
          </span>
        </div>

        <div className="col-md-5 col-12 p-4 p-md-0 d-flex flex-row align-items-center justify-content-md-end justify-content-between ">
          <div
            className="col-3  d-flex flex-row cursor-pointer align-items-center justify-content-center "
            style={{ textDecoration: "underline" }}
            onClick={() => redirect("/Privacy-Policy")}
          >
            Privacy Policy
          </div>
          <div
            className="col-3  d-flex flex-row cursor-pointer align-items-center justify-content-end "
            style={{ textDecoration: "underline" }}
          >
            <FontAwesomeIcon
              icon={faFacebookF as IconProp}
              className="me-4"
              style={{ fontSize: "3rem" }}
              onClick={() =>
                window.open(
                  "https://www.facebook.com/barbiereparrucchierepadova",
                  "_blank"
                )
              }
            />
            <FontAwesomeIcon
              icon={faTiktok as IconProp}
              className="me-4"
              onClick={() =>
                window.open(
                  "https://www.tiktok.com/@iscavazzonparrucchiere",
                  "_blank"
                )
              }
              style={{ fontSize: "3rem" }}
            />
            <FontAwesomeIcon
              icon={faInstagram as IconProp}
              onClick={() =>
                window.open(
                  "https://www.instagram.com/iscavazzon_parrucchieri/",
                  "_blank"
                )
              }
              style={{ fontSize: "3rem" }}
            />
          </div>
        </div>
      </div>
    </>
  );
};
export default Footer;
